export default [
    {
        name: 'Prefix',
        value: 's_airline_prefix'
    },
    {
        name: 'Name',
        value: 's_airline_name'
    },
    {
        name: 'Logo',
        value: 's_logo'
    },
    {
        name: 'Code',
        value: 's_airline_code'
    },
    {
        name: 'Created',
        value: 't_created',
        datetime: true,
        utc: true
    },
    {
        name: 'Created by',
        value: 's_created_by'
    },
    {
        name: 'Modified',
        value: 't_modified',
        datetime: true,
        utc: true
    },
    {
        name: 'Modified by',
        value: 's_modified_by'
    }
];